import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { chain, get } from 'lodash';

import { orderReducer } from 'v1/helpers/misc';
import { formatRateSummary } from 'v1/helpers/budgetHelper';
import { getFormattedEventDates } from 'v1/helpers/byModel/EventHelper';

import { EventDateRange, Flyover, RateInput } from 'v1/components/shared';
import { DialogClose } from 'v5/design-system/Dialog.js';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger
} from 'v5/design-system/Collapsible.js';
import { Calendar, Maximize2 } from 'lucide-react';
import { Button } from 'v5/design-system/Button.js';

const BookResourceFlyoverBookingContents = ({
  slot,
  event,
  setEvent,
  rate,
  setRate,
  openCreateBooking
}) => {
  const productions = useSelector(state => state.productions.data);
  const production = get(productions, [slot.production_id], {});
  const bookingTypes = useSelector(state => state.booking_types);
  const bookingTypesList = chain(orderReducer(bookingTypes))
    .filter(b => !b.archived)
    .orderBy(['order', 'asc'])
    .value();
  const bookingType = get(bookingTypesList, ['0'], null);

  useEffect(
    () =>
      setEvent({
        ...production.production_date,
        include_weekends: bookingType?.include_weekends_default // Grab system booking default and inlude weekend
      }),
    [production.production_date, setEvent]
  );

  return (
    <>
      <Collapsible>
        <CollapsibleTrigger className="p-4 text-left">
          <div className="flex items-center gap-2 text-fg-muted w-1/3">
            <Calendar className="size-5" />
            <div>Dates</div>
          </div>
          <div className="flex-1">{event && getFormattedEventDates(event)}</div>
        </CollapsibleTrigger>
        <CollapsibleContent className="p-4">
          <EventDateRange
            appearance="outline"
            size="S"
            data={event}
            allowEmpty={false}
            eventType="BOOKING"
            onChange={setEvent}
          />
        </CollapsibleContent>
      </Collapsible>
      <Collapsible>
        <CollapsibleTrigger className="p-4 text-left">
          <div className="flex items-center gap-2 text-fg-muted w-1/3">
            <img src="/images/icon_rate.svg" className="size-5" alt="" />
            <div>Rate</div>
          </div>
          <div className="flex-1">
            {formatRateSummary(rate, production.budget_currency, false)}
          </div>
        </CollapsibleTrigger>
        <CollapsibleContent className="p-4">
          <RateInput
            value={{
              currency: rate.currency,
              amount: rate.amount,
              interval: rate.interval
            }}
            defaultCurrency={production.budget_currency}
            onBlur={setRate}
          />
        </CollapsibleContent>
      </Collapsible>
      <div className="p-1">
        <DialogClose asChild className="w-full justify-between">
          <Button variant="ghost" size="md" onClick={openCreateBooking}>
            Open full booking
            <Maximize2 />
          </Button>
        </DialogClose>
      </div>
    </>
  );
};

BookResourceFlyoverBookingContents.propTypes = {
  slot: PropTypes.object,
  event: PropTypes.object,
  setEvent: PropTypes.func,
  rate: PropTypes.object,
  setRate: PropTypes.func,
  openCreateBooking: PropTypes.func
};

export default BookResourceFlyoverBookingContents;
